module.exports = __webpack_public_path__ + "static/media/IMG_7908.2cf22029.JPG";